import { render, staticRenderFns } from "./user_guide.vue?vue&type=template&id=e24f8442&scoped=true&lang=pug&"
var script = {}
import style0 from "./user_guide.vue?vue&type=style&index=0&id=e24f8442&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24f8442",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e24f8442')) {
      api.createRecord('e24f8442', component.options)
    } else {
      api.reload('e24f8442', component.options)
    }
    module.hot.accept("./user_guide.vue?vue&type=template&id=e24f8442&scoped=true&lang=pug&", function () {
      api.rerender('e24f8442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/user_guide.vue"
export default component.exports